import React from 'react';

import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import SessionApi from '@opendoor/shared-fe/build/api/session';

import { COOKIE_KEY, WEB_API_URL } from '../helpers/globals';
import { testingClient } from './apolloClients';

/**
 * This context provides a boolean flag representing whether
 * we are in test mode state or not to any component that consumes it.
 */
export const TestModeContext = React.createContext(false);

/**
 * This context provides any component that consumes it with the
 * apollo client used for test mode.
 */
export const TestClientContext =
  React.createContext<ApolloClient<NormalizedCacheObject>>(testingClient);

export const Sessions = new SessionApi(COOKIE_KEY, WEB_API_URL);
export const SessionContext = React.createContext<SessionApi>(Sessions);
